import UserSelector from './src/main';

UserSelector.install = function(Vue) {
  Vue.component(UserSelector.name, UserSelector);
};

export default UserSelector;
